const ACTIVITIES = new Set([
  '/home', '/plan/improve', '/preferences', '/lineup', '/art', '/art/contributors',
  '/plan', '/profile', '/settings', '/onboarding', '/triage', '/rate', '/priorities',
  '/conflicts', '/group', '/photos', '/messages', '/forum', '/search', '/feedback',
  '/faq', '/links', '/terms', '/privacy', '/event',
]);

// Home is where somebody lands when nothing else was asked for, because the
// planner is one reason to be here rather than the only one.
export const DEFAULT_RETURN = '/home';

export function safeReturnPath(value: unknown, fallback = DEFAULT_RETURN): string {
  if (typeof value !== 'string' || /[\\\u0000-\u0020]/.test(value)) return fallback;
  try {
    const url = new URL(value, 'https://planner.invalid');
    if (!value.startsWith('/') || url.origin !== 'https://planner.invalid') return fallback;
    if (!ACTIVITIES.has(url.pathname)) return fallback;
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
}
